import { cmsApiClient } from '@/config/httpClients';
import type { CMSBlogPageResponse } from '../getBlogContent/schemas';
import { CMSBlogPageSchema } from '../getBlogContent/schemas';
import type { QueryFunctionContext } from '@tanstack/react-query';

const getBlogRelatedArticles = async ({ queryKey }: QueryFunctionContext) => {
  const blogSlug = queryKey[1];
  const categorySlug = queryKey[2];

  const filter = `&filter[slug:isnt]=${blogSlug}&filter[categories:contains]=${categorySlug}`;

  const response = await cmsApiClient
    .get<CMSBlogPageResponse>(
      `collections/articles/entries?limit=3&sort=-date&fields=id,title,date,slug,feature_image,categories,excerpt${filter}`
    )
    .json();
  const parsedData = CMSBlogPageSchema.safeParse(response);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }
  return response.data;
};

export { getBlogRelatedArticles };
